import angular from "angular";
import panel from "../services";

function questionsProfile (panel) {

    return {
        restrict: 'E',
        scope: {
            questions: '='
        },
        link: function(scope) {
        },
        template: require('./templates/questions-profile.html')
    }
};

export default angular.module('directives.questionsProfile', [panel]).directive('questionsProfile', questionsProfile).name;


// WEBPACK FOOTER //
// ./src/app/directives/questionsProfile.js